<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  
              <router-view/>
   
  <Canvas/>
  <Sidebar/>
</template>

<script>
import Canvas from '@/components/canvas.vue' 
import Sidebar from '@/components/sidebar.vue' 
export default {
  
  components: {
    Canvas,Sidebar
  },
  mounted(){ 
  },
  methods:{
    // loadBasics(){
    //  var $main_nav = $('#main-nav');
    // var $toggle = $('.toggle');
    // var defaultOptions = {
    //     disableAt: false,
    //     customToggle: $toggle,
    //     levelSpacing: 40,
    //     navTitle: 'App',
    //     levelTitles: true,
    //     levelTitleAsBack: true,
    //     pushContent: '#container',
    //     insertClose: 2
    // };
    // var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
    // }
  }
}
</script>
<style>
.light_gray{
        background: #f6f6f6;
}
.footer_bar{
    bottom: 0;
    position: relative;
    z-index: 999;
}
.bg-primary,.footer{
    background-color: #003032 !important;
  /*background: linear-gradient(328deg, #ff0000, #000199);*/
}
.footer a{
  color: white !important;
    font-weight: 600;
}
p{
    margin-bottom: 4px;
}
.border-end{
   border-top: 1px solid #EAF1F5 !important; 
}
@media (min-width: 768px) {
    #app {
        width: 380px;
    }
}
.bg-info{
           background-color: rgb(149 242 178) !important;
    color: black !important;
}
.footer_menu img{
        width: 70%;
}
</style>
